// extracted by mini-css-extract-plugin
export var press = "subscribe-press-list-module--press--534fb";
export var pressImage = "subscribe-press-list-module--pressImage--1719f";
export var press__center = "subscribe-press-list-module--press__center--9a22a";
export var spin = "subscribe-press-list-module--spin--49f48";